import React from 'react'
import classNames from 'classnames'
import { Text } from '../../elements/Text'
import { Color, ColorName, getColorTheme, mq } from '../../utils'
import { useSpacing } from '../../providers/spacingProvider'
import { IProps } from './index'

export function HeadingBlock({
  leftAlign,
  small,
  text,
  subheading,
  bgColor,
  eyebrow,
  headingMode,
}: IProps) {
  headingMode = !headingMode ? 'standard' : headingMode
  let headingTheme = ''
  let bgColorTheme
  if (bgColor) {
    bgColorTheme = getColorTheme('default', bgColor)
    headingTheme = `heading-block--${ColorName[bgColorTheme.id as Color]}`
  }

  const headingContent = (
    <Text brand="default" size={small ? 'heading-2' : 'heading-1-small'}>
      {text}
    </Text>
  )

  const spacing = useSpacing()

  const headingClass = classNames('heading-block', {
    'heading-block--padding': !spacing,
  })

  return (
    <div className={`${headingClass} ${headingMode} ${headingTheme}`}>
      <article className="content">
        {eyebrow ? (
          <div className="heading-block__eyebrow">
            <Text brand="default" size="eyebrows">
              {eyebrow}
            </Text>
          </div>
        ) : null}

        {headingMode === 'standard' ? <h1>{headingContent}</h1> : <h2>{headingContent}</h2>}

        {subheading && (
          <div className="subheading">
            <Text brand="default" size="heading-4">
              {subheading}
            </Text>
          </div>
        )}
      </article>

      <style jsx>
        {`
          .heading-block {
            display: block;
            padding-left: 0;
            padding-right: 0;
            text-align: ${leftAlign ? 'left' : 'center'};
            color: ${bgColorTheme ? bgColorTheme.textColor : 'initial'};
            background-color: ${bgColorTheme ? bgColorTheme.id : 'initial'};
            display: grid;

            &--padding {
              padding-top: 1.5rem;
              padding-bottom: 1.5rem;
            }
          }

          .content {
            grid-column: content;
          }
          .heading-block.compact {
            grid-template-columns: ${small && !leftAlign
              ? '1fr [content] 12fr 1fr'
              : '2fr [content] 10fr 2fr'};
          }

          .heading-block__eyebrow {
            padding-bottom: 0;
          }

          .subheading {
            max-width: 48.5rem;
            margin: 16px auto 0;
          }

          @media (${mq.mobile}) {
            .heading-block {
              grid-template-columns: 1fr [content] 12fr 1fr;
            }
          }

          @media (${mq.tablet}) {
            .heading-block {
              grid-template-columns: 2fr [content] 10fr 2fr;
              padding-left: 0;
              padding-right: 0;

              &--padding {
                padding-top: 1.5rem;
                padding-bottom: 1.5rem;
              }
            }
          }
          @media (${mq.laptop}) {
            padding: 24px 0;
            .heading-block {
              grid-template-columns: ${small
                ? '3fr [content] 8fr 3fr'
                : '2.5fr [content] 9fr 2.5fr'};
            }
          }
          @media (${mq.desktop}) {
            .heading-block {
              grid-template-columns: ${small
                ? '4fr [content] 6fr 4fr'
                : '2.8fr [content] 8.4fr 2.8fr'};
              padding-left: 0;
              padding-right: 0;

              &--padding {
                padding-top: 1.5rem;
                padding-bottom: 1.5rem;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
